// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","text-color-2":"#333333","table-header-bg-color":"#f4f8fb","table":"List_table__28qSJ"};